<template>
  <v-dialog v-model="isOpened" max-width="400px" persistent @click:outside="handleCancel">
    <v-card>
      <v-card-title class="pb-2">
        <span class="text-h6">로그인</span>
      </v-card-title>
      
      <v-card-text class="pb-2">
        <v-form @submit.prevent="handleSubmit">
          <v-text-field
            v-model="name"
            label="이름"
            placeholder="이름을 입력하세요"
            variant="outlined"
            density="compact"
            required
            ref="nameInput"
            class="mb-2"
          ></v-text-field>
          
          <v-text-field
            v-model="password"
            label="비밀번호"
            placeholder="비밀번호를 입력하세요"
            variant="outlined"
            density="compact"
            type="password"
            required
            class="mb-2"
            @keyup.enter="handleSubmit"
          ></v-text-field>
        </v-form>
      </v-card-text>
      
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="grey"
          variant="text"
          @click="handleCancel"
          :disabled="isLoading"
          size="small"
        >
          취소
        </v-btn>
        <v-btn
          color="primary"
          variant="text"
          @click="handleSubmit"
          :loading="isLoading"
          size="small"
        >
          로그인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';
import { useUserLoginStore } from "@/stores/userLogin";
import { storeToRefs } from "pinia";

const store = useUserLoginStore();
const { isOpened, name, password, isLoading } = storeToRefs(store);
const { close } = store;

const nameInput = ref(null);

// 취소 처리
const handleCancel = () => {
  close(null);
};

// 제출 처리
const handleSubmit = () => {
  if (!name.value.trim() || !password.value) {
    return;
  }
  
  // 로그인 데이터를 반환
  close({
    name: name.value,
    password: password.value
  });
};

// 다이얼로그 열림/닫힘 감지
watch(isOpened, async (newValue) => {
  if (newValue) {
    // 다이얼로그가 열리면 첫 번째 입력필드에 포커스
    await nextTick();
    nameInput.value?.focus();
  }
});
</script>

<style scoped>
</style>
